import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./routes/app";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginRoute from "./routes/login";
import Home from "./container/app/home";
import sdkContext from "./context/sdk";
import { LeapEVMSdk, chainConfig } from "@leapwallet/leap-evm-js";
import { MantineProvider } from "@mantine/core";
import NFTRoute from "./routes/nfts";
import RoadMapRoute from "./routes/roadmap";

const root = ReactDOM.createRoot(document.getElementById("root"));

const Root = () => {
  const [leapSdk, setLeapSdk] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // const subscribeAuthEvents = (auth, leapSdk) => {
    //   auth.on(ADAPTER_EVENTS.CONNECTED, async (data) => {
    //     const user = await leapSdk.auth.getUser();
    //     setUser((s) => (s ? { ...s, user } : user));
    //   });
    // };
    async function init() {
      const loginService = localStorage.getItem("login_service");
      if (!loginService) {
        return setLoading(false);
      }
      const leapSdk = await LeapEVMSdk.init(chainConfig.avalanche.testnet, {
        auth_service: loginService,
      });
      try {
        const user = await leapSdk.auth.getUser();
        if (loginService === "web3auth") {
          user.address = localStorage.getItem("address");
        }
        setUser(user);
      } catch (error) {
      } finally {
        setLoading(false);
      }
      setLeapSdk(leapSdk);
    }
    init();
  }, []);
  return (
    <>
      <MantineProvider withNormalizeCSS>
        <sdkContext.Provider value={{ leapSdk, user, loading, setUser }}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<App />}>
                <Route index element={<Home />} />
                <Route path="/login" element={<LoginRoute />} />
                <Route path="/nfts" element={<NFTRoute />} />
                <Route path="/roadmap" element={<RoadMapRoute />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </sdkContext.Provider>
      </MantineProvider>
    </>
  );
};

root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
